export default function SummaryCards({ cards }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <article
          key={card.label}
          className={`rounded-2xl border border-gray-200 p-4 shadow-sm ${card.cardClass}`}
        >
          <p className="text-sm font-medium text-gray-500">{card.label}</p>
          <p className={`mt-2 text-4xl font-bold ${card.valueClass}`}>{card.value}</p>
          <p className="mt-2 text-xs text-gray-500">{card.hint}</p>
        </article>
      ))}
    </div>
  );
}
